import { UploadError } from '@/hooks/useUpload'
import {
  FILENAME_INCORRECT_CHARACTERS,
  FILENAME_TOO_LONG,
  FILE_INCORRECT_EXTENSIONS,
  FILE_INCORRECT_TYPE,
  FILE_TOO_LARGE,
} from '@/hooks/useUpload/error'
import { ATTACHMENT_EXTENSIONS } from '@/hooks/useUpload/fileTypeLists'
import { ALLOWED_FILENAME_CHARS_REGEX } from '@/hooks/useUpload/filenameValidation'
import { getExtension } from '@/hooks/useUpload/helpers'

export const validateFileType = (
  file: File,
  allowedExtensions: string[],
  allowedMimes: string[]
) => {
  const fileName = file.name.toLowerCase()
  const fileExtension = getExtension(fileName)

  // Validate file extension
  if (!allowedExtensions.includes(fileExtension)) {
    throw new UploadError(
      FILE_INCORRECT_EXTENSIONS(allowedExtensions, fileExtension),
      {
        fileName: file.name,
        fileType: file.type,
        allowedExtensions,
      }
    )
  }

  // Some browsers report an empty MIME type for these, and the extension
  // check above already passed
  if (ATTACHMENT_EXTENSIONS.includes(fileExtension) && !file.type) {
    return
  }

  // Validate file MIME type
  if (!allowedMimes.includes(file.type)) {
    throw new UploadError(FILE_INCORRECT_TYPE, {
      fileName: file.name,
      fileType: file.type,
    })
  }
}

export const validateFileName = (
  file: File,
  maxLength: number,
  filenameIncorrectCharacters = FILENAME_INCORRECT_CHARACTERS
) => {
  const fileName = file.name

  if (!ALLOWED_FILENAME_CHARS_REGEX.test(fileName)) {
    throw new UploadError(filenameIncorrectCharacters, { fileName })
  }
  if (fileName.length > maxLength) {
    throw new UploadError(FILENAME_TOO_LONG(maxLength), {
      fileName,
      maxFileNameLength: maxLength,
    })
  }
}

export const validateFileSize = (file: File, maxSizeInBytes: number) => {
  const fileSize = file.size

  if (fileSize > maxSizeInBytes) {
    throw new UploadError(FILE_TOO_LARGE, {
      fileName: file.name,
      fileSize,
      maxFileSizeInBytes: maxSizeInBytes,
    })
  }
}
